import API from 'services/TAPS_API';

export default function postData(data) {
  return API.request({
    method: 'POST',
    url: `/notification/1150117`,
    data,
  });
}
